import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const userData = JSON.parse(localStorage.getItem('userData'))
const posUser = JSON.parse(localStorage.getItem('posUserData'))
const detailingUser = JSON.parse(localStorage.getItem('detailingUserData'))

let existingAbility = userData ? userData.ability : null
// POS / Detailing sessions are separate from Clinico userData — grant full menu access
if (!existingAbility && (posUser || detailingUser)) {
  existingAbility = [{ action: 'manage', subject: 'all' }]
}

export default new Ability(existingAbility || initialAbility)
